const BUILD_FOR_TESTING = "false"

export default BUILD_FOR_TESTING